import type { RouteObject } from "react-router-dom";
import CreateMCPClass from "@/pages/mcp/CreateMCPClass";
import CreateMCPInstance from "@/pages/mcp/CreateMCPInstance";
import CreateMCPInstanceFromClass from "@/pages/mcp/CreateMCPInstanceFromClass";
import EditMCPClass from "@/pages/mcp/EditMCPClass";
import EditMCPInstance from "@/pages/mcp/EditMCPInstance";
import MCPClassDetail from "@/pages/mcp/MCPClassDetail";
import MCPInstanceDetail from "@/pages/mcp/MCPInstanceDetail";
import MCPs from "@/pages/mcp/MCPs";



// TODO(perf): lazy-load these non-first-screen pages with a shared, accessible Suspense fallback.
export const mcpRoutes: RouteObject[] = [
  { path: "/plugins/mcps", element: <MCPs /> },
  {
    path: "/plugins/mcps/classes/new",
    element: <CreateMCPClass />,
  },
  {
    path: "/plugins/mcps/classes/:id",
    element: <MCPClassDetail />,
  },
  {
    path: "/plugins/mcps/classes/:id/edit",
    element: <EditMCPClass />,
  },
  {
    path: "/plugins/mcps/classes/:id/instances/new",
    element: <CreateMCPInstanceFromClass />,
  },
  {
    path: "/plugins/mcps/instances/new",
    element: <CreateMCPInstance />,
  },
  {
    path: "/plugins/mcps/instances/:id",
    element: <MCPInstanceDetail />,
  },
  {
    path: "/plugins/mcps/instances/:id/edit",
    element: <EditMCPInstance />,
  },
];
